/**
 * Hydrates product-card videos that use <source data-src> (no src until hover/focus).
 * Keeps MP4 off the network until the user hovers or focuses the card (desktop saves bandwidth;
 * mobile cards hide these videos via CSS, so sources often never hydrate).
 *
 * PERF: On init, ANY <source> with a real src inside a [data-lazy-hover] video is
 * demoted to data-src. This defends against regressions where Shopify's media_tag
 * or an app injects a hover video with a real src (which browsers prefetch even
 * with preload="none" when autoplay is set).
 */
(function () {
  'use strict';

  function absoluteUrl(url) {
    if (!url) return '';
    var s = String(url).trim();
    if (/^https?:\/\//i.test(s)) return s;
    if (s.indexOf('//') === 0) return 'https:' + s;
    return s;
  }

  function demoteRealSrc(video) {
    // If a <source> shipped with a real src, move it to data-src so the browser
    // doesn't race to prefetch before we want it to.
    video.querySelectorAll('source[src]:not([data-src])').forEach(function (el) {
      el.setAttribute('data-src', el.getAttribute('src'));
      el.removeAttribute('src');
    });
    // If the video itself has a real src, demote that too.
    if (video.hasAttribute('src') && !video.hasAttribute('data-src')) {
      video.setAttribute('data-src', video.getAttribute('src'));
      video.removeAttribute('src');
    }
    try { video.load(); } catch (e) {}
  }

  function hydrateVideo(video) {
    if (video.dataset.lazyLoaded === 'true') return;
    video.dataset.lazyLoaded = 'true';
    var sources = video.querySelectorAll('source[data-src]');
    var promoted = false;
    sources.forEach(function (el) {
      var raw = el.getAttribute('data-src');
      el.setAttribute('src', absoluteUrl(raw));
      el.removeAttribute('data-src');
      promoted = true;
    });
    if (video.hasAttribute('data-src') && !video.hasAttribute('src')) {
      video.setAttribute('src', absoluteUrl(video.getAttribute('data-src')));
      video.removeAttribute('data-src');
      promoted = true;
    }
    if (!promoted) return;
    video.load();
    if (video.hasAttribute('autoplay')) {
      video.play().catch(function () {});
    }
  }

  function bindCard(container) {
    var videos = container.querySelectorAll('video[data-lazy-hover]');
    if (!videos.length) return;

    // Defensive pass: demote any real src BEFORE the browser can act on it.
    videos.forEach(demoteRealSrc);

    var done = false;
    function onFirstInteract() {
      if (done) return;
      done = true;
      videos.forEach(hydrateVideo);
      container.removeEventListener('mouseenter', onFirstInteract);
      container.removeEventListener('focusin', onFirstInteract);
    }

    container.addEventListener('mouseenter', onFirstInteract, { passive: true });
    container.addEventListener('focusin', onFirstInteract);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('hover-images').forEach(bindCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
